import {
  AnyAction,
  createAsyncThunk,
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";
import {
  TasksInitialStateDTO,
  UpdateTaskAssigneeDTO,
  UpdateTaskPriorityDTO,
  UpdateTaskStatusDTO,
} from "./types";
import {
  GetAllTaskByAssignee,
  GetAllTaskByDateForAssignee,
  GetAllTaskType,
  GetTaskBoard,
  GetTaskById,
  GetTaskCount,
  SendRemainders,
  UpdateTaskAssignee,
  UpdateTaskPriority,
  UpdateTaskStatus,
} from "./tasks.request";
import { setToastNotification } from "../../../../components/ToastNotification/service/toastNotificationSlice";

export const initialState: TasksInitialStateDTO = {
  success: false,
  error: false,
  loading: false,
  tasksByAssignee: null,
  tasksTypes: null,
  tasksboard: null,
  taskById: null,
  tasksByDateForAssignee: null,
  taskStatusUpdateSuccess: false,
  taskStatusUpdateError: false,
  taskStatusUpdateLoading: false,
  taskPriorityUpdateSuccess: false,
  taskPriorityUpdateError: false,
  taskPriorityUpdateLoading: false,
  taskAssigneeUpdateSuccess: false,
  taskAssigneeUpdateError: false,
  taskAssigneeUpdateLoading: false,
  taskByIdLoading: false,
  taskBoardloading: false,
  sendRemaindersLoading: false,
  sendRemaindersSuccess: false,
  sendRemaindersError: false,
  taskCountLoading: false,
  taskCountSuccess: false,
  taskCountError: false,
  taskCountLength: null,
};

export const gettasksByAssignee = createAsyncThunk(
  "tasks/gettasksByAssignee",
  async (id: string, thunkAPI: any) => {
    return GetAllTaskByAssignee(id)
      .then((response: any) => {
        return response?.data?.data;
      })
      .catch(function (e: any) {
        throw e.response.data;
      });
  }
);

export const getAllTasksType = createAsyncThunk(
  "tasks/getAllTasksType",
  async (id: string, thunkAPI: any) => {
    return GetAllTaskType(id)
      .then((response: any) => {
        return response?.data?.data;
      })
      .catch(function (e: any) {
        throw e.response.data;
      });
  }
);

export const updateTaskStatus = createAsyncThunk(
  "tasks/updateTaskStatus",
  async (data: UpdateTaskStatusDTO, thunkAPI: any) => {
    return UpdateTaskStatus(data)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

// export const gettasksBoard = createAsyncThunk(
//   "tasks/gettasksBoard",
//   async (data: any, thunkAPI: any) => {
//     return GetTaskBoard(
//       data.id,
//       data.startDate,
//       data.endDate,
//       data.taskType,
//       data.priority
//     )
//       .then((response: any) => {
//         return response?.data?.data;
//       })
//       .catch(function (e: any) {
//         throw e.response.data;
//       });
//   }
// );
export const gettasksBoard = createAsyncThunk(
  "tasks/gettasksBoard",
  async (data: any, thunkAPI: any) => {
    return GetTaskBoard(data)
      .then((response: any) => {
        const apiResponse = response?.data?.data;


        const isKanbanFormat = Array.isArray(apiResponse) && apiResponse.length > 0 && apiResponse[0]?.tasks?.data;

        const state = thunkAPI.getState();
        const lastCreatedComment = state?.nurture?.lastCreatedComment;

        if (lastCreatedComment && lastCreatedComment.isGeneralTaskComment && apiResponse) {
          let commentFoundInAPI = false;

          const checkForComment = (task: any) => {
            if (String(task.id) === String(lastCreatedComment.taskId)) {
              const commentList = task.commentList || [];
              commentFoundInAPI = commentList.some(
                (c: any) => String(c.id) === String(lastCreatedComment.id)
              );
            }
          };

          if (isKanbanFormat) {
            apiResponse.forEach((column: any) => {
              if (Array.isArray(column?.tasks?.data)) {
                column.tasks.data.forEach(checkForComment);
              }
            });
          } else if (Array.isArray(apiResponse)) {
            apiResponse.forEach(checkForComment);
          }

          if (commentFoundInAPI) {
            thunkAPI.dispatch({
              type: 'nurture/clearLastCreatedComment'
            });
          }
        }

        return apiResponse;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const gettasksByDateForAssignee = createAsyncThunk(
  "tasks/gettasksByDateForAssignee",
  async (data: any, thunkAPI: any) => {
    return GetAllTaskByDateForAssignee(data)
      .then((response: any) => {
        return response?.data?.data;
      })
      .catch(function (e: any) {
        throw e.response.data;
      });
  }
);

export const getTaskById = createAsyncThunk(
  "tasks/getTaskById",
  async (data: { id: string; taskCategory?: string }, thunkAPI: any) => {
    return GetTaskById(data.id, data.taskCategory)
      .then((response: any) => {
        return response?.data?.data;
      })
      .catch(function (e: any) {
        throw e.response.data;
      });
  }
);

export const updateTaskPriority = createAsyncThunk(
  "tasks/updateTaskPriority",
  async (data: UpdateTaskPriorityDTO, thunkAPI: any) => {
    return UpdateTaskPriority(data)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const updateTaskAssignee = createAsyncThunk(
  "tasks/updateTaskAssignee",
  async (data: UpdateTaskAssigneeDTO, thunkAPI: any) => {
    return UpdateTaskAssignee(data)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const sendRemainders = createAsyncThunk(
  "tasks/sendRemainders",
  async (data: any, thunkAPI: any) => {
    return SendRemainders(data)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const getTaskCount = createAsyncThunk(
  "tasks/getTaskCount",
  async (data: any, thunkAPI: any) => {
    return GetTaskCount(data)
      .then((response: any) => {
        // if (response) {
        //   thunkAPI.dispatch(
        //     setToastNotification({
        //       message: response?.data?.message,
        //       type: "success",
        //       snackOpen: true,
        //     })
        //   );
        // }
        return response?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const tasksSlice = createSlice({
  name: "tasks",
  initialState,
  reducers: {
    reset: () => initialState,
    resetTaskById: (state) => {
      state.taskById = null;
    },
    resetTaskUpdateSuccess: (state) => {
      state.taskStatusUpdateSuccess = false;
    },
    resetTaskPriorityUpdateSuccess: (state) => {
      state.taskPriorityUpdateSuccess = false;
    },
    resetTaskAssigneeUpdateSuccess: (state) => {
      state.taskAssigneeUpdateSuccess = false;
    },
    resetTaskErrors: (state) => {
      state.taskStatusUpdateError = false;
      state.taskAssigneeUpdateError = false;
      state.taskPriorityUpdateError = false;
    },
    resetTaskBoard: (state) => {
      state.tasksboard = null;
    },
    resetSendRemainders: (state) => {
      state.sendRemaindersSuccess = false;
    },
    removeCommentFromTask: (state, action: PayloadAction<{ taskId: string | number; commentId: string | number }>) => {
      const { taskId, commentId } = action.payload;

      if (!state.tasksboard) {
        return;
      }

      const isKanbanFormat = Array.isArray(state.tasksboard) && state.tasksboard.length > 0 && state.tasksboard[0]?.tasks?.data;

      let commentRemoved = false;

      if (isKanbanFormat) {
        state.tasksboard.forEach((column: any) => {
          if (Array.isArray(column?.tasks?.data)) {
            column.tasks.data.forEach((task: any) => {
              if (String(task.id) === String(taskId) && Array.isArray(task.commentList)) {
                const originalLength = task.commentList.length;
                task.commentList = task.commentList.filter(
                  (comment: any) => String(comment.id) !== String(commentId)
                );
                if (task.commentList.length !== originalLength) {
                  commentRemoved = true;
                }
              }
            });
          }
        });
      } else {
        if (Array.isArray(state.tasksboard)) {
          state.tasksboard.forEach((task: any) => {
            if (String(task.id) === String(taskId) && Array.isArray(task.commentList)) {
              const originalLength = task.commentList.length;
              task.commentList = task.commentList.filter(
                (comment: any) => String(comment.id) !== String(commentId)
              );
              if (task.commentList.length !== originalLength) {
                commentRemoved = true;
              }
            }
          });
        }
      }
    },
    addCommentToTask: (state, action: PayloadAction<{ taskId: string | number; comment: any }>) => {
      const { taskId, comment } = action.payload;

      if (!state.tasksboard) {
        return;
      }

      const isKanbanFormat = Array.isArray(state.tasksboard) && state.tasksboard.length > 0 && state.tasksboard[0]?.tasks?.data;

      let commentAdded = false;

      if (isKanbanFormat) {
        let taskFound = false;
        state.tasksboard.forEach((column: any) => {
          if (Array.isArray(column?.tasks?.data)) {
            column.tasks.data.forEach((task: any) => {
              const taskIdStr = String(task.id);
              const searchTaskIdStr = String(taskId);
              if (taskIdStr === searchTaskIdStr) {
                taskFound = true;
                if (!Array.isArray(task.commentList)) {
                  task.commentList = [];
                }
                const commentExists = task.commentList.some(
                  (c: any) => String(c.id) === String(comment.id)
                );
                if (!commentExists) {
                  const originalLength = task.commentList.length;
                  task.commentList = [...task.commentList, comment];
                  commentAdded = true;
                }
              }
            });
          }
        });

      } else {
        if (Array.isArray(state.tasksboard)) {
          let taskFound = false;
          state.tasksboard.forEach((task: any) => {
            const taskIdStr = String(task.id);
            const searchTaskIdStr = String(taskId);
            if (taskIdStr === searchTaskIdStr) {
              taskFound = true;
              if (!Array.isArray(task.commentList)) {
                task.commentList = [];
              }
              const commentExists = task.commentList.some(
                (c: any) => String(c.id) === String(comment.id)
              );
              if (!commentExists) {
                const originalLength = task.commentList.length;
                task.commentList = [...task.commentList, comment];
                commentAdded = true;
              }
            }
          });

        }
      }

    },
    updateCommentInTask: (state, action: PayloadAction<{ taskId: string | number; comment: any }>) => {
      const { taskId, comment } = action.payload;

      if (!state.tasksboard) return;

      const isKanbanFormat = Array.isArray(state.tasksboard) && state.tasksboard.length > 0 && state.tasksboard[0]?.tasks?.data;

      if (isKanbanFormat) {
        state.tasksboard.forEach((column: any) => {
          if (Array.isArray(column?.tasks?.data)) {
            column.tasks.data.forEach((task: any) => {
              if (String(task.id) === String(taskId) && Array.isArray(task.commentList)) {
                const commentIndex = task.commentList.findIndex(
                  (c: any) => String(c.id) === String(comment.id)
                );
                if (commentIndex !== -1) {
                  task.commentList[commentIndex] = { ...task.commentList[commentIndex], ...comment };
                }
              }
            });
          }
        });
      } else {
        if (Array.isArray(state.tasksboard)) {
          state.tasksboard.forEach((task: any) => {
            if (String(task.id) === String(taskId) && Array.isArray(task.commentList)) {
              const commentIndex = task.commentList.findIndex(
                (c: any) => String(c.id) === String(comment.id)
              );
              if (commentIndex !== -1) {
                task.commentList[commentIndex] = { ...task.commentList[commentIndex], ...comment };
              }
            }
          });
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(gettasksByAssignee.pending, (state) => {
      state.loading = true;
      state.success = false;
      state.error = false;
    });
    builder.addCase(
      gettasksByAssignee.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.success = true;
        state.error = false;
        state.tasksByAssignee = action?.payload;
      }
    );
    builder.addCase(gettasksByAssignee.rejected, (state, action: AnyAction) => {
      state.loading = false;
      state.success = false;
      state.error = action?.error?.message || "Something went wrong";
    });
    builder.addCase(getAllTasksType.pending, (state) => {
      state.loading = true;
      state.success = false;
      state.error = false;
    });
    builder.addCase(
      getAllTasksType.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.success = true;
        state.error = false;
        state.tasksTypes = action?.payload;
      }
    );
    builder.addCase(getAllTasksType.rejected, (state, action: AnyAction) => {
      state.loading = false;
      state.success = false;
      state.error = action?.error?.message || "Something went wrong";
    });
    builder.addCase(updateTaskStatus.pending, (state) => {
      state.taskStatusUpdateLoading = true;
      state.taskStatusUpdateSuccess = false;
      state.taskStatusUpdateError = false;
    });
    builder.addCase(updateTaskStatus.fulfilled, (state, action: AnyAction) => {
      state.taskStatusUpdateLoading = false;
      state.taskStatusUpdateSuccess =
        action?.payload?.message || "Task Status Updated";
      state.taskStatusUpdateError = false;
    });
    builder.addCase(updateTaskStatus.rejected, (state, action: AnyAction) => {
      state.taskStatusUpdateLoading = false;
      state.taskStatusUpdateSuccess = false;
      state.taskStatusUpdateError =
        action?.payload?.message || "Something went wrong";
    });
    builder.addCase(
      gettasksBoard.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.taskBoardloading = false;
        state.success = true;
        state.error = false;

        const apiResponse = action?.payload;
        const currentTasksboard = state.tasksboard;

        if (apiResponse && currentTasksboard) {
          const isKanbanFormat = Array.isArray(apiResponse) && apiResponse.length > 0 && apiResponse[0]?.tasks?.data;

          const mergeCommentsIntoTask = (newTask: any, oldTask: any) => {
            if (!oldTask?.commentList || !Array.isArray(oldTask.commentList) || oldTask.commentList.length === 0) {
              return newTask;
            }

            if (newTask?.commentList && Array.isArray(newTask.commentList)) {
              const apiCommentIds = new Set(newTask.commentList.map((c: any) => String(c.id)));
              const oldCommentsNotInAPI = oldTask.commentList.filter(
                (c: any) => !apiCommentIds.has(String(c.id))
              );
              if (oldCommentsNotInAPI.length > 0) {
                newTask.commentList = [...newTask.commentList, ...oldCommentsNotInAPI];
              }
            } else {
              newTask.commentList = [...oldTask.commentList];
            }

            return newTask;
          };

          const findOldTask = (taskId: string | number, oldTasksboard: any, isKanban: boolean): any => {
            if (isKanban && Array.isArray(oldTasksboard)) {
              for (const column of oldTasksboard) {
                if (Array.isArray(column?.tasks?.data)) {
                  const task = column.tasks.data.find((t: any) => String(t.id) === String(taskId));
                  if (task) return task;
                }
              }
            } else if (Array.isArray(oldTasksboard)) {
              return oldTasksboard.find((t: any) => String(t.id) === String(taskId));
            }
            return null;
          };

          if (isKanbanFormat && Array.isArray(apiResponse)) {
            apiResponse.forEach((column: any) => {
              if (Array.isArray(column?.tasks?.data)) {
                column.tasks.data = column.tasks.data.map((task: any) => {
                  const oldTask = findOldTask(task.id, currentTasksboard, true);
                  return oldTask ? mergeCommentsIntoTask(task, oldTask) : task;
                });
              }
            });
            state.tasksboard = apiResponse;
          } else if (Array.isArray(apiResponse)) {
            const mergedResponse = apiResponse.map((task: any) => {
              const oldTask = findOldTask(task.id, currentTasksboard, false);
              return oldTask ? mergeCommentsIntoTask(task, oldTask) : task;
            });
            state.tasksboard = mergedResponse;
          } else {
            state.tasksboard = apiResponse;
          }
        } else {
          state.tasksboard = apiResponse;
        }

      }
    );
    builder.addCase(gettasksBoard.rejected, (state, action: AnyAction) => {
      state.taskBoardloading = false;
      state.success = false;
      state.error = action?.error?.message || "Something went wrong";
    });
    builder.addCase(gettasksBoard.pending, (state) => {
      state.taskBoardloading = true;
      state.success = false;
      state.error = false;
    });
    builder.addCase(getTaskById.pending, (state) => {
      state.taskByIdLoading = true;
      state.success = false;
      state.error = false;
    });
    builder.addCase(
      getTaskById.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.taskByIdLoading = false;
        state.success = true;
        state.error = false;
        state.taskById = action?.payload;
      }
    );
    builder.addCase(getTaskById.rejected, (state, action: AnyAction) => {
      state.taskByIdLoading = false;
      state.success = false;
      state.error = action?.error?.message || "Something went wrong";
    });
    builder.addCase(updateTaskPriority.pending, (state) => {
      state.taskPriorityUpdateLoading = true;
      state.taskPriorityUpdateSuccess = false;
      state.taskPriorityUpdateError = false;
    });
    builder.addCase(
      updateTaskPriority.fulfilled,
      (state, action: AnyAction) => {
        state.taskPriorityUpdateLoading = false;
        state.taskPriorityUpdateSuccess =
          action?.payload?.message || "Task Priority Updated";
        state.taskPriorityUpdateError = false;
      }
    );
    builder.addCase(updateTaskPriority.rejected, (state, action: AnyAction) => {
      state.taskPriorityUpdateLoading = false;
      state.taskPriorityUpdateSuccess = false;
      state.taskPriorityUpdateError =
        action?.payload?.message || "Something went wrong";
    });
    builder.addCase(updateTaskAssignee.pending, (state) => {
      state.taskAssigneeUpdateLoading = true;
      state.taskAssigneeUpdateSuccess = false;
      state.taskAssigneeUpdateError = false;
    });
    builder.addCase(
      updateTaskAssignee.fulfilled,
      (state, action: AnyAction) => {
        state.taskAssigneeUpdateLoading = false;
        state.taskAssigneeUpdateSuccess =
          action?.payload?.message || "Task Assignee Updated";
        state.taskAssigneeUpdateError = false;
      }
    );
    builder.addCase(updateTaskAssignee.rejected, (state, action: AnyAction) => {
      state.taskAssigneeUpdateLoading = false;
      state.taskAssigneeUpdateSuccess = false;
      state.taskAssigneeUpdateError =
        action?.payload?.message || "Something went wrong";
    });
    builder.addCase(gettasksByDateForAssignee.pending, (state) => {
      state.loading = true;
      state.success = false;
      state.error = false;
    });
    builder.addCase(
      gettasksByDateForAssignee.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.success = true;
        state.error = false;
        state.tasksByDateForAssignee = action?.payload;
      }
    );
    builder.addCase(
      gettasksByDateForAssignee.rejected,
      (state, action: AnyAction) => {
        state.loading = false;
        state.success = false;
        state.error = action?.error?.message || "Something went wrong";
      }
    );
    builder.addCase(sendRemainders.pending, (state) => {
      state.sendRemaindersLoading = true;
      state.sendRemaindersSuccess = false;
      state.sendRemaindersError = false;
    });
    builder.addCase(
      sendRemainders.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.sendRemaindersLoading = false;
        state.sendRemaindersSuccess = true;
        state.sendRemaindersError = false;
        state.tasksByDateForAssignee = action?.payload;
      }
    );
    builder.addCase(sendRemainders.rejected, (state, action: AnyAction) => {
      state.sendRemaindersLoading = false;
      state.sendRemaindersSuccess = false;
      state.sendRemaindersError =
        action?.error?.message || "Something went wrong";
    });
    builder.addCase(getTaskCount.pending, (state) => {
      state.taskCountLoading = true;
      state.taskCountSuccess = false;
      state.taskCountError = false;
    });
    builder.addCase(
      getTaskCount.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.taskCountLoading = false;
        state.taskCountSuccess = true;
        state.taskCountError = false;
        state.taskCountLength = action?.payload;
      }
    );
    builder.addCase(getTaskCount.rejected, (state, action: AnyAction) => {
      state.taskCountLoading = false;
      state.taskCountSuccess = false;
      state.taskCountError = action?.error?.message || "Something went wrong";
    });
  },
});

export default tasksSlice.reducer;
export const {
  reset,
  resetTaskById,
  resetTaskPriorityUpdateSuccess,
  resetTaskAssigneeUpdateSuccess,
  resetTaskUpdateSuccess,
  resetTaskErrors,
  resetTaskBoard,
  resetSendRemainders,
  removeCommentFromTask,
  addCommentToTask,
  updateCommentInTask,
} = tasksSlice.actions;
